export default "__VITE_ASSET__BNgBRyi6__"